var _rect, _path, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatternIconCreate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2.40985,
    width: 12.253,
    height: 12.253,
    rx: 2,
    fill: "#7C85AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.725 10.4617C15.6617 9.39832 15.6617 7.67429 16.725 6.61093L21.5384 1.79751C22.6018 0.734162 24.3258 0.734162 25.3892 1.79751L30.2026 6.61093C31.2659 7.67429 31.2659 9.39832 30.2026 10.4617L25.3892 15.2751C24.3258 16.3384 22.6018 16.3384 21.5384 15.2751L16.725 10.4617Z",
    fill: "#7C85AF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 18.747,
    width: 12.253,
    height: 12.253,
    rx: 2,
    fill: "#7C85AF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3374,
    y: 18.747,
    width: 12.253,
    height: 12.253,
    rx: 2,
    fill: "#7C85AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternIconCreate);
export default __webpack_public_path__ + "static/media/pattern-icon-create.f594fa5f430dea4dcbc6663ae6f52e94.svg";
export { ForwardRef as ReactComponent };